import React, { Component } from 'react'
import { Form, Field } from 'redux-form'
import Button from 'components/Button'

import { Elements, ElementsConsumer, CardElement } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'

import InputMessage from '../../../components/Input/InputMessage'
import CheckboxRow from 'components/Input/CheckboxRow'
import { vRequired } from 'components/Input/Input.validations'

import config from 'src/config'

import cn from 'classnames'
import sLay from 'styles/modules/layout.scss'
import sMarg from 'styles/modules/margins.scss'
import sText from 'components/Text/Text.scss'
import s from './BillingAddCreditCardForm.scss'

const stripe = loadStripe(config.other.stripePublicKey)

export default class BillingAddCreditCardForm extends Component {
  state = {
    creditCard: {
      error: undefined,
      empty: true,
      complete: false,
    },
    submitting: false,
  }

  render() {
    const {
      handleSubmit,
      updateCreditCard,
      ban,
      onCancel,
      afterSubmit,
      loading,
      isConfirmed,
    } = this.props

    const CARD_ELEMENT_OPTIONS = {
      style: {
        base: {
          fontSize: '20px',
        },
      },
      hidePostalCode: true,
    }

    return (
      <Elements stripe={stripe}>
        <ElementsConsumer>
          {({ elements, stripe }) => {
            const onSubmit = async () => {
              this.setState({ submitting: true })

              const result = await stripe
                .createPaymentMethod({
                  type: 'card',
                  card: elements.getElement(CardElement),
                })
                .finally(() => this.setState({ submitting: false }))

              if (result.error || !result.paymentMethod) {
                const error = result.error || { message: 'Something goes wrong, please retry' }
                this.setState({
                  creditCard: {
                    error,
                  },
                })

                return
              }

              this.setState({ submitting: true })

              // send payment method to backend
              await updateCreditCard({
                ban,
                paymentMethodId: result.paymentMethod.id,
              }).finally(() => this.setState({ submitting: false }))

              if (afterSubmit) {
                afterSubmit()
              }
            }

            return (
              <Form onSubmit={handleSubmit(onSubmit)}>
                <div className={s.ccCountryNotice}>
                  <b>Note:</b> We only accept Australian cards.
                </div>

                <CardElement
                  options={CARD_ELEMENT_OPTIONS}
                  onChange={event => {
                    this.setState({
                      creditCard: {
                        error: event.error,
                        empty: event.empty,
                        complete: event.complete,
                      },
                    })
                  }}
                />
                <InputMessage error={this.state.creditCard.error?.message} touched />

                <div className={cn(sText.descrip4, sMarg.mv30)}>
                  1.9% payment surcharge applies.{' '}
                  <a
                    href="https://helpcentre.thinkpickle.com.au/account-management/avoiding-credit-card-surcharge"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Learn more.
                  </a>
                </div>

                <Field
                  name="confirm"
                  component={CheckboxRow}
                  style={{ margin: '30px 0' }}
                  validate={[vRequired]}
                >
                  I understand and agree to the payment and direct debit{' '}
                  <a href="/payment-terms" target="_blank" rel="noopener noreferrer">
                    terms and conditions
                  </a>{' '}
                  and I acknowledge that these terms are binding on me or the company that I am to
                  represent.
                </Field>

                <div
                  className={cn(sLay['layout-column'], sLay['layout-align-center-center'])}
                  style={{ marginTop: '40px' }}
                >
                  <Button
                    color="tertiary"
                    type="submit"
                    loading={loading || this.state.submitting}
                    disabled={
                      !stripe ||
                      !elements ||
                      !this.state.creditCard.complete ||
                      loading ||
                      this.state.submitting ||
                      !isConfirmed
                    }
                  >
                    Save
                  </Button>
                  <br />
                  <br />
                  <Button plain onClick={onCancel}>
                    Cancel
                  </Button>
                </div>
              </Form>
            )
          }}
        </ElementsConsumer>
      </Elements>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Billing/BillingAddCreditCardForm/BillingAddCreditCardForm.jsx